/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CalendarHeading.vue?vue&type=template&id=87bda8c8&scoped=true&"
import script from "./CalendarHeading.vue?vue&type=script&lang=js&"
export * from "./CalendarHeading.vue?vue&type=script&lang=js&"
import style0 from "./CalendarHeading.vue?vue&type=style&index=0&id=87bda8c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bda8c8",
  null
  
)

export default component.exports